import { gql } from "@apollo/client";

export const GET_CULTURE = gql`
  query culture {
    cultureSetting {
      code {
        code
      }
      displayText
      abbreviation
      country{
        contentItems{
          __typename
          ... on Country{
            code{
              code
            },
            callingCode,
            name
          }
        }
      }
      currency {
        contentItems {
          __typename
          ... on Currency {
            code {
              code
            }
            displayText
            abbreviation
            ratio
          }
        }
      }
      amDesignator
      pmDesignator
      direction
      lang
      generalSeparator
      dateSeparator
      timeSeparator
      dateTimeSeparator
      defaultDateFormat
      defaultDateTimeFormat  
      leapMonth
      months {
        contentItems{
          __typename
          ... on Month {
            displayText
            abbreviation
            season
            totalDays
          }}
      }
      weekDays {
        contentItems {
          __typename
          ... on WeekDay {
            sort
            day
            displayText
            abbreviation
          }
        }
      }
      numbers {
        contentItems {
          __typename
          ... on Number {
            number
            displayText
            ordinal
          }
        }
      }
    }
  }
`;

export const GET_VOCAB = gql`
  query Vocab($culture: String!) {
    vocab(where: {localization: {culture: $culture}}) {
      key
      value
    }
  }
`;
